import React, { useState } from "react";
import { motion } from "framer-motion";
import image from "../../assets/teacher-traning.jpeg";
import { Link } from "react-router-dom";
import AppointmentModal from "../../global/AppointmentModal";
const FeatureValue2 = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="w-full bg-[#00294b] flex justify-center items-center sm:py-[5rem] pt-[4rem] pb-[3rem]">
      <div className="container flex lg:flex-row flex-col items-center justify-center gap-4 px-4 sm:px-0">
        {/* Image on Left */}
        <div className="lg:w-1/2 w-full flex justify-center items-center">
          <img src={image} alt="teacher_traning" className="lg:w-[80%] sm:w-[80%] w-[90%] sm:h-[25rem] rounded-xl shadow-[0_0_14px_8px_#22beff]" loading="lazy"/>
        </div>
        {/* Text on Right */}
        <motion.div
          initial={{ opacity: 0.5, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: false }}
          className="lg:w-1/2 w-full flex flex-col gap-4 lg:items-start items-center justify-center mt-[2rem] lg:mt-0"
        >
          <h2 className="lg:text-5xl text-2xl lg:text-start text-center text-[#22beff] font-bold">
            QS টিচার্স ট্রেনিং
          </h2>

          <h2 className="lg:text-xl text-base text-justify font-medium">
            <span className="text-[#bfbfbf]">
             QS Academy-এর QS টিচার্স ট্রেনিং একটি effective, Interactive এবং ফলভিত্তিক প্রশিক্ষণ প্রোগ্রাম যা শিক্ষকদের শেখাবে কীভাবে Outcome Based Education পদ্ধতি কার্যকরভাবে শ্রেণিকক্ষে প্রয়োগ করবেন। এই প্রশিক্ষণ শিক্ষককে শুধু শিক্ষক নয়, বরং একজন শিক্ষাদর্শন-নির্ভর Academic Leader হিসেবে গড়ে তুলবে।
            </span>{" "}
           
          </h2>
        

          <div className="flex items-start gap-4 mt-4">
            <button className="px-[1.25rem] py-[0.8rem] text-base border border-[#22beff] bg-[#22beff] text-[#081a28] rounded-md font-medium cursor-pointer hover:text-white" onClick={() => setShowModal(true)}>
              অ্যাপয়েন্টমেন্ট
            </button>
            <Link to="/qs-academy/test-learning/teacher-traning" className="px-[1.25rem] py-[0.8rem] text-base border border-[#22beff]  text-[#22beff] hover:text-[#081a28] hover:bg-[#22beff] rounded-md font-medium cursor-pointer">
              বিস্তারিত পড়ুন
            </Link>
          </div>
        </motion.div>
      </div>
      <AppointmentModal showModal={showModal} setShowModal={setShowModal}/>
    </div>
  );
};

export default FeatureValue2;
